/**
 * Validation schema for registration form fields
 */

export const validationSchema = {
  fullName: {
    validate: (value) => {
      if (!value?.trim()) return "Full Name is required";
      if (value.trim().length < 2) return "Minimum 2 characters required";
      if (!/^[a-zA-Z\s]+$/.test(value)) return "Only letters allowed";
      return null;
    },
  },

  email: {
    validate: (value) => {
      if (!value?.trim()) return "Email is required";
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!regex.test(value)) return "Invalid email format";
      return null;
    },
  },

  password: {
    validate: (value) => {
      if (!value) return "Password is required";
      if (value.length < 8) return "Min 8 characters required";
      if (!/[A-Z]/.test(value)) return "1 uppercase required";
      if (!/[a-z]/.test(value)) return "1 lowercase required";
      if (!/[0-9]/.test(value)) return "1 number required";
      if (!/[!@#$%^&*]/.test(value)) return "1 special character required";
      return null;
    },
  },

  mobile: {
    validate: (value) => {
      if (!value?.trim()) return "Mobile is required";
      const cleaned = value.replace(/^\+?\d{1,3}/, "").trim();
      if (!/^[0-9]{7,15}$/.test(cleaned)) {
        return "Enter valid 7–15 digit number";
      }
      return null;
    },
  },

  dob: {
    validate: (value) => {
      if (!value) return "Date of Birth is required";
      const date = new Date(value);
      if (date > new Date()) return "Invalid Date of Birth";
      return null;
    },
  },

  birthTime: {
  validate: (value) => {
    if (!value) return "Time of Birth is required";
    return null;
  },
},

  gender: {
    validate: (value) => {
      if (!value) return "Gender is required";
      return null;
    },
  },

  motherTongue: {
    validate: (value) => {
      if (!value) return "Mother Tongue is required";
      return null;
    },
  },

  profileCreatedBy: {
    validate: (value) => {
      if (!value?.trim()) return "Profile Created By is required";
      return null;
    },
  },

  maritalStatus: {
    validate: (value) => (!value ? "Marital Status is required" : null),
  },

  children: {
    validate: (value) => (!value ? "No. of Children is required" : null),
  },

  kidsLiveWith: {
    validate: (value) => {
      if (!value) return "Kids Live With is required";
      return null;
    },
  },

  religion: {
    validate: (value) => (!value ? "Religion is required" : null),
  },

  caste: {
    validate: (value) => (!value ? "Caste is required" : null),
  },

  zodiac: {
    validate: (value) => {
      if (!value) return "Zodiac (Rasi) is required";
      return null;
    },
  },

  star: {
    validate: (value) => (!value ? "Star is required" : null),
  },

  starPatham: {
  validate: (value) => {
    if (!value) return "Star Patham is required";
    return null;
  },
},
  bodyType: {
    validate: (value) => (!value ? "Body Type is required" : null),
  },

  physicalStatus: {
    validate: (value) => (!value ? "Physical Status is required" : null),
  },

  height: {
    validate: (value) => (!value ? "Height is required" : null),
  },

  weight: {
    validate: (value) => (!value ? "Weight is required" : null),
  },

  complexion: {
    validate: (value) => (!value ? "Complexion is required" : null),
  },

  birthCountry: {
    validate: (value) => (!value ? "Birth Country is required" : null),
  },

  residentCountry: {
    validate: (value) => (!value ? "Resident Country is required" : null),
  },

  residentStatus: {
    validate: (value) => (!value ? "Resident Status is required" : null),
  },

  city: {
    validate: (value) => (!value?.trim() ? "City is required" : null),
  },

  address: {
    validate: (value) => (!value?.trim() ? "Address is required" : null),
  },

  education: {
    validate: (value) => (!value?.trim() ? "Education is required" : null),
  },

  occupation: {
    validate: (value) => (!value?.trim() ? "Occupation is required" : null),
  },

  fatherPlace: {
    validate: (value) => (!value?.trim() ? "Father Native Place is required" : null),
  },

  motherPlace: {
    validate: (value) => (!value?.trim() ? "Mother Native Place is required" : null),
  },

  fatherCaste: {
    validate: (value) => (!value ? "Father Caste is required" : null),
  },

  motherCaste: {
    validate: (value) => (!value ? "Mother Caste is required" : null),
  },

  fatherOccupation: {
    validate: (value) => (!value?.trim() ? "Father Occupation is required" : null),
  },

  motherOccupation: {
    validate: (value) => (!value?.trim() ? "Mother Occupation is required" : null),
  },

  

  eating: {
    validate: (value) => (!value ? "Eating Habit is required" : null),
  },

  drinking: {
    validate: (value) => (!value ? "Drinking Habit is required" : null),
  },

  smoking: {
    validate: (value) => (!value ? "Smoking Habit is required" : null),
  },

  sevvaiLakna: {
    validate: (value) => (!value ? "Sevvai Lakna is required" : null),
  },

  photo: {
    validate: (value) => {
      if (!value) return "Photo is required";

      const maxSize = 5 * 1024 * 1024; // 5MB
      if (value.size > maxSize) return "Photo must be less than 5MB";

      return null;
    },
  },

  horoscope: {
    validate: (value) => {
      if (!value) return "Horoscope is required";

      const maxSize = 5 * 1024 * 1024; // 5MB
      if (value.size > maxSize) return "Horoscope must be less than 5MB";

      return null;
    },
  },
};

/**
 * Validate a single field
 */
export const validateField = (fieldName, value) => {
  if (!validationSchema[fieldName]) return null;
  return validationSchema[fieldName].validate(value);
};

/**
 * Validate all fields
 */
export const validateAllFields = (formData) => {
  const errors = {};

  Object.keys(validationSchema).forEach((field) => {
    const error = validateField(field, formData[field]);
    if (error) errors[field] = error;
  });

  return errors;
};

export default validationSchema;